import { Component, AfterViewInit, Input } from '@angular/core';
import { LoaderEnabled } from '../../../../../../shared/components/loader/loader.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { CoreServiceRegistry } from '../../../../../../core/core-service-registry';

@Component({
  selector: 'lfwms-asn-sku-image-acc-content',
  templateUrl: './asn-sku-image-acc-content.component.html',
  styleUrls: ['./asn-sku-image-acc-content.component.css']
})
export class AsnSkuImageAccContentComponent implements AfterViewInit {

  public imgUrlArray: Array<any> = [];
  public index: number = 0;
  public currentImgUrl: string = '';
  public showImgViewer: boolean = false;
  public http$: HttpClient;
  @Input()
  public asnCellDataMap: any;

  ngAfterViewInit() {
   // console.log(this.asnCellDataMap['storerKey'].cVal,this.asnCellDataMap['receiptKey'].cVal,
   // this.asnCellDataMap['poKey'].cVal,this.asnCellDataMap['poKey'].cVal);

    const storerKey: string = this.asnCellDataMap['storerKey'].cVal;
    const receiptKey: string = this.asnCellDataMap['receiptKey'].cVal;
    const pOKey: string = this.asnCellDataMap['poKey'].cVal;
    const externPOKey: string = '';

  /*  const storerKey: string = '2157' ; // this.cellDataMap['storerKey'].cVal;
    const receiptKey: string = '0000062558'; // this.cellDataMap['sku'].cVal;
    const pOKey: string = '0000019180' ; // this.cellDataMap['storerKey'].cVal;
    const externPOKey: string = 'OT90007729';*/
    this.getImageUrl(storerKey, receiptKey, pOKey,  externPOKey).subscribe((response) => {
       this.imgUrlArray = response['results'] ? response['results'] : [];
    });
  }
  constructor(protected coreServiceRegistry: CoreServiceRegistry) {
    this.http$ = coreServiceRegistry.http$;
    }

    public openImgInFullView(index: number) {
      this.currentImgUrl = this.imgUrlArray[index]['ImageURL'];
      this.index = index;
      this.showImgViewer = this.currentImgUrl ? true : false;
    }

    /**
     * navigate To Next Or Previous Image
     */
    public navigateToNextOrPreviousImage(nextOrPrevious: string) {
        this.index = nextOrPrevious === 'next' ?  this.index + 1 : this.index - 1;
        this.currentImgUrl = this.imgUrlArray[this.index]['ImageURL'];
    }


    @LoaderEnabled()
    public getImageUrl(storerKey: string, receiptKey: string, pOKey: string,  externPOKey: string ): Observable<any> {
      const request = {
                        'storerKey': storerKey,
                        'receiptKey': receiptKey,
                        'externReceiptKey': '',
                        'pOKey': pOKey,
                        'externPOKey': externPOKey,
                        'docRef01': '',
                        'docRef02': '',
                        'docRef03': ''
                    };

        const response$ = this.http$.post(`api/asn/image/url/`, JSON.stringify(request))
        .map((response: any) => {
          return response;
        })
        .catch((error: any) => {
          if (error.error.length !== 0) {
            if (error.error.statusCode !== 200) {
              return Observable.throw(error.error.statusMessage);
            }
          }
        });
      return response$;
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inbound/asn/asn-home/asn-details/asn-sku-image-acc-content/asn-sku-image-acc-content.component.ts